/*
Knob Pulls
  --diameter <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Knob'
const id = 'LBXl4O1B6iq8DpVycXw4'

export default {
  name,
  id,
  filters,
  headers,
  form
}
